import { CONSTANT } from "../../utils/Constants";
import { privateFetch } from "../../utils/CustomFetch.js";
import { URL } from "../../utils/UrlConstants";

export interface EmailRecipient {
  name: string;
  email: string;
}

export interface FileAttachment {
  fileName: string;
  mimeType: string;
  content: string;
  inline?: boolean;
}

export interface NotificationPayload {
  templateId: string;
  subject: string;
  recipients: EmailRecipient[];
  parameters?: Record<string, any>;
  attachments?: FileAttachment[];
}

export const sendEmailNotification = async (
  payload: NotificationPayload
): Promise<void> => {
  try {
    await privateFetch.post(
      URL.REQUEST_SEND_EMAIL,
      JSON.stringify(payload),
      {
        headers: {
          ...CONSTANT.HEADER_TYPE,
        },
      }
    );
  } catch (error: any) {
    throw new Error(error.response?.data?.message || "Error sending email");
  }
};
